import { Shell, hot } from 'repluggable';
import {
  DocumentServicesAPI,
  EditorPointerAPI,
  ExperimentsAPI,
} from '@wix/editorx-core-api';
import { EditorPlatformHostIntegrationAPI } from '@wix/editor-platform-host-integration-apis';
import { createEditorPlatformHostIntegrationAPI } from './createEditorPlatformHostIntegrationAPI';
import { WorspaceApiSlot } from './apis/utils/workspaceApiAdapter';
import { DocumentOverridesAPIKey } from '@wix/editor-platform-feature-store';
import { EditorPlatformBridgeInitializer } from './editor-platform-packages-bridge/editorPlatformBridgeInitializer';

export const EditorPlatformHostIntegrationPackage = hot(module, [
  {
    name: 'EDITOR_PLATFORM_HOST_INTEGRATION_API',

    layer: 'SITE',

    getDependencyAPIs() {
      return [
        DocumentServicesAPI,
        WorspaceApiSlot,
        ExperimentsAPI,
        EditorPointerAPI,
      ];
    },

    declareAPIs() {
      return [EditorPlatformHostIntegrationAPI, DocumentOverridesAPIKey];
    },

    attach(shell: Shell) {
      shell.contributeAPI(EditorPlatformHostIntegrationAPI, () =>
        createEditorPlatformHostIntegrationAPI(shell),
      );
    },
  },
  EditorPlatformBridgeInitializer,
]);
